import Tag from '@/shared/Tags/Tag'
import calendarPageConstants from '../../../calendar.constants'
import { TMaintenanceEventType } from '../../../calendar.types'
import calendarUtils from '../../../calendar.utils'
interface IProps {
  eventType: TMaintenanceEventType
}

const MaintenanceEventTypeLabel = (props: IProps) => {
  return (
    <Tag color={calendarUtils.getStateColor(props.eventType)} style={{ height: 'fit-content' }}>
      <p className="text-caption" style={{ color: 'inherit' }}>
        {calendarPageConstants.maintenanceEventTypes[props.eventType]}
      </p>
    </Tag>
  )
}

export default MaintenanceEventTypeLabel
